import { motion } from 'framer-motion'
import styled from 'styled-components'
import { MotionWrapper } from 'src/theme/styled'

import { mq, pxToRem, sizes } from '../../../theme'
import ActionButton from '../../ActionButton'
import Picture from '../../Picture'
import RichText from '../../RichText'
import RoundedTag from '../../RoundedTag'

export const Container = styled.hgroup<{ $color?: string }>`
  display: flex;
  background-color: ${({ $color }) => $color};
  flex-flow: column;
  padding-block-start: var(--g_height__header);

  @media ${mq(sizes.desktop)} {
    flex-flow: row;
    align-items: center;
    padding-block-start: var(--g_height__logo);
  }
`

export const Content = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  padding-inline: ${pxToRem(16)};
  padding-block: ${pxToRem(32)};
  @media ${mq(sizes.desktop)} {
    display: grid;
    grid-template-columns: minmax(min(${pxToRem(448)}, 100%), 62%);
    justify-content: center;
    align-content: center;
    gap: ${pxToRem(40)};
    padding-inline: ${pxToRem(32)};
  }
`

export const _MotionWrapper = styled(MotionWrapper)`
  padding-top: 0.075em;
`

export const Title = styled.h1`
  overflow: hidden;
  ${({ theme }) => theme.textStyles.m375_h1}
  @media ${mq(sizes.big)} {
    ${({ theme }) => theme.textStyles.d1440_h1}
  }
`
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.m375_bodyBig}
  @media ${mq(sizes.big)} {
    ${({ theme }) => theme.textStyles.d1440_bodyBig}
  }
`

export const PictureContainer = styled(motion.div)`
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    align-self: stretch;
    flex: 0 0 auto;
    width: calc(712 / 1440 * 100%);
  }
`

export const _Picture = styled(motion(Picture))`
  @media ${mq(sizes.desktop)} {
    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`
export const _ActionButton = styled(ActionButton)`
  align-self: start;
  justify-self: start;
`
export const _RoundedTag = styled(RoundedTag)`
  align-self: start;
  justify-self: start;
`
export const KeyFigures = styled(motion.p)`
  display: flex;
  gap: ${pxToRem(24)};
  align-items: flex-start;
  & > span {
    display: flex;
    gap: 0.3em;
  }

  & > span:first-child {
    ${({ theme }) => theme.textStyles.m375_keyNumbersSmall}
  }
  & > span:last-child {
    ${({ theme }) => theme.textStyles.m375_bodySmall};
    align-self: flex-end;
    margin-block-end: 0.3em;
  }
  @media ${mq(sizes.desktop)} {
    & > span:first-child {
      ${({ theme }) => theme.textStyles.m375_keyNumbers}
    }
    & > span:last-child {
      ${({ theme }) => theme.textStyles.d1440_body}
    }
  }
`
